import {Component, OnInit, ViewChild} from '@angular/core';
import {ApiService} from '../../services/api/api.service';
import {Router} from '@angular/router';
import {ModalController, Platform} from '@ionic/angular';
import {UtilsService} from '../../services/utils/utils.service';
import {SessionService} from '../../services/session/session.service';
import {UsersService} from '../../services/users/users.service';
import {RadiusService} from '../../services/radius/radius.service';
import {BrandsService} from '../../services/brands/brands.service';
import {LocationService} from '../../services/location/location.service';
import {AdContext} from '../../components/integration-ad-carousel/integration-ad-carousel.component';
import {MessageService, MessageType} from '../../services/message/message.service';
import {CommissionJunctionService} from '../../services/commissionjunction/commissionjunction.service';

@Component({
  selector: 'app-explore',
  templateUrl: './explore.component.html',
  styleUrls: ['./explore.component.scss'],
})
export class ExploreComponent implements OnInit {

  @ViewChild('searchbar', {static: false}) searchbar;

  protected myBalance;
  protected bandsConfig = [];
  protected adc = AdContext;
  protected PRODUCTS_ONLY = this.brandsService.getUIConfig().productsOnly;
  protected emptyMessage;
  private extraSearchResults = [];
  protected filteredExtraSearchResults = [];
  private subscription;
  private allItemsInBands = [];
  private allItems = [];

  constructor(
      private platform: Platform,
      private modalCtrl: ModalController,
      private router: Router,
      private sessionService: SessionService,
      private utilsService: UtilsService,
      private usersService: UsersService,
      private radiusService: RadiusService,
      apiService: ApiService,
      private brandsService: BrandsService,
      private locationService: LocationService,
      private messageService: MessageService,
      private cjService: CommissionJunctionService
  ) {
  }

  ngOnInit() {
    this.subscription = this.messageService
        .onMessage<{ items: any, allItems: any }>(MessageType.ReportCarouselItems)
        .subscribe(payload => {
          if (payload.items) {
            this.allItemsInBands = this.allItemsInBands.concat(payload.items);
            this.allItemsInBands = this.utilsService.uniqBy(this.allItemsInBands, 'id');
          }
          if (payload.allItems) {
            this.allItems = payload.allItems;
          }
          this.extraSearchResults = this.allItems.filter(item => !this.allItemsInBands.find(bandItem => bandItem.id === item.id));
        });
    this.loadBands();
    this.usersService.meSubscribe((data) => {
      this.bandsConfig = JSON.parse(JSON.stringify(this.bandsConfig));
    });
  }

  private loadBands() {
    const config = this.brandsService.getConfigJSON();
    this.bandsConfig = config.bands;
    this.emptyMessage = config.content.messages.emptyExplorePageMessage || '';
  }

  doRefresh(event) {
    this.bandsConfig = JSON.parse(JSON.stringify(this.bandsConfig));
    setTimeout(() => event.target.complete(), 1000);
  }

  /*
  doSearch() {
    if (this.searchbar.value) {
      this.locationService.here().then(location => {
        this.router.navigate(['/rebatelist', this.searchbar.value, location.latitude, location.longitude, '25']);
      });
    }
  }
   */

  incrementalSearch() {
    if (this.searchbar.value) {
      this.filteredExtraSearchResults = this.utilsService.bandFilter(this.extraSearchResults, this.searchbar.value, null);
    } else {
      this.filteredExtraSearchResults = [];
    }
    this.allItemsInBands = [];
    this.messageService.sendMessage(MessageType.SetCarouselSearch, {filter: this.searchbar.value});
  }

}
